import { ChartConfiguration } from "chart.js";

export class ChartJsDirectiveController {
  static $inject = [];

  config!: ChartConfiguration;

  constructor() {}
}
